import {useSelector} from 'react-redux';

import appConfig from '@/config/appConfig.typed';
import {filterSectionsById} from '@/services/pageSectionService';
import {selectIsAnyConsumerProducts, selectIsConsumerProductsFetched} from '@/state/selectors/consumer';
import {selectIsLoyaltyMember, selectLoyaltyPoints} from '@/state/selectors/consumerLoyalty';

import {getLoyaltyButtonsBar} from './getLoyaltyButtonsBar';

const useHomePageTopBannerData = ({id}) => {
    const banners = appConfig.getTopBanners();
    const topBannerData = filterSectionsById({list: banners, id})[0];
    const isLoyaltyEnabled = appConfig.getIsLoyaltyEnabled();
    const isLoyaltyApiEnabled = appConfig.getIsLoyaltyApiEnabled();
    const isLoyaltyUser = useSelector(selectIsLoyaltyMember);
    const loyaltyPoints = useSelector(selectLoyaltyPoints);
    const isConsumerProductsFetched = useSelector(selectIsConsumerProductsFetched);
    const isAnyConsumerProducts = useSelector(selectIsAnyConsumerProducts);

    const {loyaltyButtonsBar, topBanner, loyaltyTopBanner, noLoyaltyTopBanner, loyaltyNoPointsTopBanner} =
        topBannerData || {};

    const loyaltyButtons = getLoyaltyButtonsBar({loyaltyButtonsBar});

    if (topBanner && !loyaltyNoPointsTopBanner && !loyaltyTopBanner && !noLoyaltyTopBanner)
        return {bannerData: topBanner};

    if (!isLoyaltyEnabled || !isLoyaltyApiEnabled) return {bannerData: topBanner};

    if (!isLoyaltyUser) return {bannerData: noLoyaltyTopBanner};

    // Return object with empty topBanner to show welcome screen with no background while ConsumerProducts is loading
    if (!isConsumerProductsFetched) return {bannerData: {}};

    if (loyaltyPoints > 0 && isAnyConsumerProducts)
        return {
            bannerData: loyaltyTopBanner,
            isLoyaltyBanner: true,
            loyaltyButtons,
        };

    return {bannerData: loyaltyNoPointsTopBanner};
};

export default useHomePageTopBannerData;
